import React from 'react';
import type { HeadlineSegment } from '../../types/landing';
type LandingHeroProps = {
  eyebrow: string;
  headline: HeadlineSegment[];
};
export function LandingHero({
  eyebrow,
  headline
}: LandingHeroProps) {
  return <section className="mx-auto max-w-3xl px-6 pt-8 text-center md:pt-10" data-id="element-20" data-mp="2sbh69xsz6t4n">
      <p className="font-display text-lg italic text-ink/80" data-id="element-21" data-mp="2x8zf7o6zt8cn">{eyebrow}</p>
      <h1 className="mt-3 [text-wrap:balance] font-heading text-[1.75rem] font-light uppercase leading-[1.25] tracking-[0.06em] text-logo md:text-[2rem]" data-id="element-22" data-mp="3kz3i1tccx42l">
        {headline.map((segment, i) => {
        if (segment.emphasis === 'underline') {
          return <span key={i} className="underline decoration-1 underline-offset-[6px]" data-id="element-23" data-mp="3b0nqjp9f3ssk">
                {segment.text}
              </span>;
        }
        if (segment.emphasis === 'strong') {
          return <strong key={i} className="font-semibold underline decoration-2 underline-offset-[6px]" data-id="element-24" data-mp="24ktpen130t5y">
                {segment.text}
              </strong>;
        }
        return <span key={i} data-id="element-25" data-mp="2tew5uiwp8hyl" data-mpi={i}>{segment.text}</span>;
      })}
      </h1>
    </section>;
}